/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInventoryCostRevaluation = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m10.75 1.82 8.75 5.47V9h-.963l-6.787 4.242v5.391l1.72-1.075 1.06 1.696-3.78 2.363L2 16.148V7.29zm-1 16.813v-5.391L4 9.648v5.392zM4.887 7.843l5.863 3.665 5.863-3.664-5.863-3.665zM17.5 12v-1h2v1H22v2h-2.5v2h.75c1.64 0 2.75 1.473 2.75 3s-1.11 3-2.75 3h-.75v1h-2v-1H15v-2h2.5v-2h-.75C15.11 18 14 16.527 14 15s1.11-3 2.75-3zm0 2h-.75c-.293 0-.75.318-.75 1 0 .682.457 1 .75 1h.75zm2 4v2h.75c.293 0 .75-.318.75-1 0-.682-.457-1-.75-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgInventoryCostRevaluation as InventoryCostRevaluation };
